export enum WorkOrderStatus {
  SUBMITTED = 'SUBMITTED',
  SCHEDULED = 'SCHEDULED',
  COMPLETED = 'COMPLETED',
  // Not in the BE contract yet; values still assumed.
  ON_HOLD = 'ON_HOLD',
  ARCHIVED = 'ARCHIVED',
}
